/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Main.module.css';
import data from '../../logic/data';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class ExampleHeader extends Component {
  render() {
    const {groupIdx, exampleIdx} = this.props;
    const subHeader = data.examples[0][exampleIdx].subHeaderText.map((el, idx) => 
      <span key={idx}>{el}</span>);
    return (
      <div className={styles.heading}>
        <h2 className={styles.mainHeading}>
          {data.examples[0][exampleIdx].headerText}
        </h2>
        <div className={styles.subHeading}>{subHeader}</div>
      </div>
    );
  }
}

export default ExampleHeader;
